import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart3 } from 'lucide-react';

export const ChartPlaceholder = ({ title = 'Chart', height = 300 }) => {
  return (
    <Card className="card-elevated">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div 
          className="flex items-center justify-center rounded-lg border-2 border-dashed border-muted-foreground/20 bg-muted/20"
          style={{ height: `${height}px` }}
        >
          <div className="text-center">
            <BarChart3 className="mx-auto h-12 w-12 text-muted-foreground/40" />
            <p className="mt-2 text-sm text-muted-foreground">Chart Placeholder</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
